import axios from "@/utils/request/instance";

export class VadServiceMonitor {
  private static instance: VadServiceMonitor;
  private isLocalAvailable: boolean = false;
  private checkInterval: number = 5 * 60 * 1000; // 5分钟检查一次
  private timer: NodeJS.Timeout | null = null;

  private constructor() {
    // 立即进行第一次检查
    this.checkLocalService();
    // 启动定时检查
    this.startMonitoring();
  }

  static getInstance(): VadServiceMonitor {
    if (!VadServiceMonitor.instance) {
      VadServiceMonitor.instance = new VadServiceMonitor();
    }
    return VadServiceMonitor.instance;
  }

  private async checkLocalService() {
    try {
      const response = await axios({
        method: "post",
        url: "http://localhost:7770/vad",
        headers: { "Content-Type": "application/octet-stream" },
        data: new Uint8Array(0),  // 空数据
      });
      if (response.status === 200) {
        this.isLocalAvailable = true;
      } else {
        throw new Error('本地 VAD 服务检查失败');
      }
    } catch (error) {
      this.isLocalAvailable = false;
    }
  }

  private startMonitoring() {
    this.timer = setInterval(() => {
      this.checkLocalService();
    }, this.checkInterval);
  }

  public isAvailable(): boolean {
    return this.isLocalAvailable;
  }

  // 清理定时器
  public destroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
